import { useState } from 'react'
import { Check, Copy as CopyIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { Copy } from '@/frontend/pages/Dashboard/Workflows/types'

export default function JsonPanel({ title, value, unavailable, copy }: { title: string; value: unknown; unavailable?: string | null; copy: Copy }) {
  const [message, setMessage] = useState<string | null>(null)
  const text = JSON.stringify(value, null, 2)
  async function copyJson() {
    try { await navigator.clipboard.writeText(text); setMessage(copy.execution.copied) }
    catch { setMessage(copy.execution.copy_failed) }
  }
  return <section className="min-w-0 space-y-3" aria-label={title}>
    <div className="flex items-center justify-between gap-2"><h2 className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{title}</h2>
      {!unavailable && text !== undefined && <Button variant="ghost" size="icon-sm" className="size-6" onClick={copyJson} aria-label={copy.execution.copy_json} title={copy.execution.copy_json}>
        {message === copy.execution.copied ? <Check className="size-3 text-success" aria-hidden /> : <CopyIcon className="size-3 text-faint-foreground" aria-hidden />}
      </Button>}
    </div>
    {unavailable || text === undefined ? <p className="text-[13px] leading-relaxed text-muted-foreground">{unavailable ?? copy.shared.not_informed}</p> : <pre className="max-h-80 overflow-auto whitespace-pre-wrap break-words rounded-lg border bg-muted/30 px-3 py-2.5 font-mono text-xs leading-relaxed">{text}</pre>}
    {message && <p role="status" className="text-xs text-muted-foreground">{message}</p>}
  </section>
}
